<template>
  <li>
    <a href="#" @click="$emit('onChooseProject', project.id)">
      <div class="pull-left">
        <img :src="'/image/Project/' + project.imageUrl + '?' + Date.now()" class="img-circle" alt="User Image">
      </div>
      <h4>
        <span>{{project.name}}</span>
        <!-- <small>
          <i class="icon ion-clock-o"></i>
          <span>{{project.name}}</span>
        </small> -->
      </h4>
      <p>{{project.city}}</p>
    </a>
  </li>
</template>

<script>
export default {
  name: 'ProjectItem',
  props: ['project'],
  data() {
    return {
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>
.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > h4,
.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > p {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// ProjectItem.vue?17d1447a